import { render } from "./CustomLabel.vue?vue&type=template&id=4d7b9ce4&ts=true"
import script from "./CustomLabel.vue?vue&type=script&lang=ts"
export * from "./CustomLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__